import { withDefaults } from './with-defaults';

export function withArrayDefaults<T, D extends { [key in keyof T]?: T[key] }>(array: T[], defaults: D): Array<D & T> {
    return array.map(obj => withDefaults(obj, defaults));
}
